// src/pages/documentation/DocumentationIndex.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faQrcode,
    faStore,
    faUsers,
    faBullhorn,
    faGift,
    faChartBar,
    faEnvelope,
    faMobileAlt,
    faArrowRight,
    faCheckCircle,
    faRocket,
    faCog,
    faChartLine,
    faFileAlt,
    faPoll,
    faBell,
    faUser,
    faUserTie,
    faCrown,
    faTags,
    faBox,
    faUserClock,
    faImage
} from '@fortawesome/free-solid-svg-icons';
import DocumentationLayout from '../../components/documentation/DocumentationLayout';

const DocumentationIndex = () => {
    const guides = [
        // Quick Start
        {
            id: 'quick-start',
            title: 'Inicio Rápido',
            description: 'Guía completa para crear tu cuenta, iniciar sesión y configurar tu negocio paso a paso.',
            icon: faRocket,
            path: '/documentation/quick-start',
            category: 'Quick Start',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        // Gestión
        {
            id: 'gestion',
            title: 'Gestión de tu Negocio',
            description: 'Aprende a administrar marcas, tiendas, clientes, productos y ventas en PetitPrime.',
            icon: faCog,
            path: '/documentation/gestion',
            category: 'Gestión',
            status: 'disponible',
            estimatedTime: 'Variable'
        },
        {
            id: 'gestion-marcas-tiendas',
            title: 'Gestión de Marcas y Tiendas',
            description: 'Crea y gestiona tus marcas y tiendas, configura logos, recompensas y puntos.',
            icon: faStore,
            path: '/documentation/gestion/marcas-tiendas',
            category: 'Gestión',
            status: 'disponible',
            estimatedTime: '20 min'
        },
        {
            id: 'gestion-clientes',
            title: 'Gestión de Clientes',
            description: 'Gestiona tus clientes, acumula puntos, canjea premios y segmenta por RFM.',
            icon: faUsers,
            path: '/documentation/gestion/clientes',
            category: 'Gestión',
            status: 'disponible',
            estimatedTime: '25 min'
        },
        {
            id: 'gestion-productos',
            title: 'Gestión de Productos',
            description: 'Crea y gestiona tu catálogo de productos, categorías e inventario.',
            icon: faBox,
            path: '/documentation/gestion/productos',
            category: 'Gestión',
            status: 'disponible',
            estimatedTime: '20 min'
        },
        {
            id: 'gestion-ventas',
            title: 'Gestión de Ventas',
            description: 'Importa y analiza tus ventas, mapea campos con IA y procesa transacciones.',
            icon: faChartBar,
            path: '/documentation/gestion/ventas',
            category: 'Gestión',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        // Marketing
        {
            id: 'marketing',
            title: 'Marketing',
            description: 'Herramientas completas de marketing: ofertas, WinBack, recompensas, email e infografías.',
            icon: faBullhorn,
            path: '/documentation/marketing',
            category: 'Marketing',
            status: 'disponible',
            estimatedTime: 'Variable'
        },
        {
            id: 'marketing-ofertas',
            title: 'Gestión de Ofertas',
            description: 'Crea y gestiona ofertas promocionales (descuentos, 2x1) y analiza su rendimiento.',
            icon: faTags,
            path: '/documentation/marketing/ofertas',
            category: 'Marketing',
            status: 'disponible',
            estimatedTime: '20 min'
        },
        {
            id: 'marketing-winback',
            title: 'Recuperar Clientes Perdidos',
            description: 'Sistema inteligente para recuperar clientes inactivos automáticamente.',
            icon: faUserClock,
            path: '/documentation/marketing/winback',
            category: 'Marketing',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        {
            id: 'marketing-recompensas',
            title: 'Gestión de Recompensas',
            description: 'Crea premios y descuentos, envíalos a clientes y gestiona su canje.',
            icon: faGift,
            path: '/documentation/marketing/recompensas',
            category: 'Marketing',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        {
            id: 'marketing-email',
            title: 'Email Marketing',
            description: 'Crea y envía campañas de email con editor WYSIWYG y segmentación avanzada.',
            icon: faEnvelope,
            path: '/documentation/marketing/email-marketing',
            category: 'Marketing',
            status: 'disponible',
            estimatedTime: '25 min'
        },
        {
            id: 'marketing-infografias',
            title: 'Generar Infografías',
            description: 'Crea infografías profesionales con editor visual y exporta en PDF o PNG.',
            icon: faImage,
            path: '/documentation/marketing/infografias',
            category: 'Marketing',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        // Analytics
        {
            id: 'analytics',
            title: 'Analytics y Reportes',
            description: 'Analiza el rendimiento con dashboards, estadísticas y reportes ejecutivos.',
            icon: faChartLine,
            path: '/documentation/analytics',
            category: 'Analytics',
            status: 'disponible',
            estimatedTime: 'Variable'
        },
        {
            id: 'analytics-dashboard',
            title: 'Dashboard Analytics',
            description: 'Visión analítica completa con KPIs y gráficos interactivos.',
            icon: faChartLine,
            path: '/documentation/analytics/dashboard',
            category: 'Analytics',
            status: 'disponible',
            estimatedTime: '10 min'
        },
        {
            id: 'analytics-clientes',
            title: 'Estadísticas de Clientes',
            description: 'Análisis detallado del comportamiento y métricas de tus clientes.',
            icon: faUsers,
            path: '/documentation/analytics/clientes',
            category: 'Analytics',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        {
            id: 'analytics-tiendas',
            title: 'Estadísticas de Tiendas',
            description: 'Métricas específicas de rendimiento por tienda para comparar y optimizar.',
            icon: faStore,
            path: '/documentation/analytics/tiendas',
            category: 'Analytics',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        {
            id: 'analytics-ofertas',
            title: 'Métricas de Ofertas',
            description: 'Analiza el rendimiento de tus ofertas promocionales y optimiza campañas.',
            icon: faTags,
            path: '/documentation/analytics/ofertas',
            category: 'Analytics',
            status: 'disponible',
            estimatedTime: '10 min'
        },
        {
            id: 'analytics-reporting',
            title: 'Centro de Reporting',
            description: 'Genera reportes ejecutivos profesionales con análisis avanzados y recomendaciones de IA.',
            icon: faFileAlt,
            path: '/documentation/analytics/reporting',
            category: 'Analytics',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        // Feedback y Alertas
        {
            id: 'feedback',
            title: 'Feedback y Alertas',
            description: 'Recopila feedback de clientes con encuestas y mantente informado con alertas automáticas.',
            icon: faPoll,
            path: '/documentation/feedback',
            category: 'Feedback',
            status: 'disponible',
            estimatedTime: 'Variable'
        },
        {
            id: 'feedback-encuestas',
            title: 'Encuestas de Satisfacción',
            description: 'Crea y gestiona encuestas para recopilar feedback valioso de tus clientes.',
            icon: faPoll,
            path: '/documentation/feedback/encuestas',
            category: 'Feedback',
            status: 'disponible',
            estimatedTime: '15 min'
        },
        {
            id: 'feedback-alertas',
            title: 'Centro de Alertas',
            description: 'Gestiona alertas automáticas sobre eventos importantes como cumpleaños y objetivos.',
            icon: faBell,
            path: '/documentation/feedback/alertas',
            category: 'Feedback',
            status: 'disponible',
            estimatedTime: '10 min'
        },
        // Usuarios
        {
            id: 'usuarios',
            title: 'Tipos de Usuarios',
            description: 'Conoce los diferentes tipos de usuarios: dueño de marca, trabajador y franquiciado.',
            icon: faUser,
            path: '/documentation/usuarios',
            category: 'Usuarios',
            status: 'disponible',
            estimatedTime: 'Variable'
        },
        {
            id: 'usuarios-dueño',
            title: 'Dueño de la Marca',
            description: 'Usuario principal con acceso completo a todas las funcionalidades de la plataforma.',
            icon: faCrown,
            path: '/documentation/usuarios/dueño',
            category: 'Usuarios',
            status: 'disponible',
            estimatedTime: '5 min'
        },
        {
            id: 'usuarios-trabajador',
            title: 'Trabajador',
            description: 'Personal de tienda con acceso limitado para gestionar clientes y operaciones diarias.',
            icon: faUserTie,
            path: '/documentation/usuarios/trabajador',
            category: 'Usuarios',
            status: 'disponible',
            estimatedTime: '10 min'
        },
        {
            id: 'usuarios-franquiciado',
            title: 'Franquiciado',
            description: 'Dueño de franquicia con acceso a estadísticas y gestión operativa de sus tiendas.',
            icon: faStore,
            path: '/documentation/usuarios/franquiciado',
            category: 'Usuarios',
            status: 'disponible',
            estimatedTime: '10 min'
        },
        // Integraciones
        {
            id: 'tpv-agora',
            title: 'TPV Agora',
            description: 'Configura tu Terminal de Punto de Venta con Agora Software para acumulación automática de puntos.',
            icon: faQrcode,
            path: '/documentation/integraciones/tpv-agora',
            category: 'Integraciones',
            status: 'disponible',
            estimatedTime: '15 min'
        }
    ];

    const categories = [
        { id: 'Quick Start', guides: guides.filter(g => g.category === 'Quick Start') },
        { id: 'Gestión', guides: guides.filter(g => g.category === 'Gestión') },
        { id: 'Marketing', guides: guides.filter(g => g.category === 'Marketing') },
        { id: 'Analytics', guides: guides.filter(g => g.category === 'Analytics') },
        { id: 'Feedback', guides: guides.filter(g => g.category === 'Feedback') },
        { id: 'Usuarios', guides: guides.filter(g => g.category === 'Usuarios') },
        { id: 'Integraciones', guides: guides.filter(g => g.category === 'Integraciones') }
    ].filter(cat => cat.guides.length > 0);

    return (
        <DocumentationLayout>
            <div className="p-8">
                {/* Header */}
                <div className="mb-8 text-center">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl mb-4 shadow-lg">
                        <FontAwesomeIcon icon={faRocket} className="text-white text-2xl" />
                    </div>
                    <h1 className="text-4xl font-bold text-gray-800 mb-3">Centro de Ayuda</h1>
                    <p className="text-gray-600 text-lg max-w-3xl mx-auto">
                        Encuentra guías paso a paso para configurar y usar todas las funcionalidades de PetitPrime. Todo lo que necesitas para gestionar y hacer crecer tu negocio está aquí.
                    </p>
                </div>

                {/* Welcome Banner */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6 mb-8">
                    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900 mb-2">👋 ¿Es tu primera vez aquí?</h2>
                            <p className="text-gray-700">
                                Comienza con nuestra guía de bienvenida para conocer PetitPrime y luego sigue con el inicio rápido para configurar tu cuenta.
                            </p>
                        </div>
                        <div className="flex flex-col gap-2">
                            <Link
                                to="/documentation/welcome"
                                className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
                            >
                                Ver Presentación
                                <FontAwesomeIcon icon={faArrowRight} />
                            </Link>
                            <Link
                                to="/documentation/quick-start"
                                className="inline-flex items-center gap-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors font-medium"
                            >
                                <FontAwesomeIcon icon={faRocket} />
                                Inicio Rápido
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Guides by Category */}
                <div className="space-y-10">
                    {categories.map((category) => (
                        <div key={category.id} className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
                            <div className="flex items-center gap-3 mb-6">
                                <div className={`p-2 rounded-lg ${category.id === 'Quick Start' ? 'bg-blue-100' :
                                    category.id === 'Gestión' ? 'bg-green-100' :
                                        category.id === 'Marketing' ? 'bg-purple-100' :
                                            category.id === 'Analytics' ? 'bg-indigo-100' :
                                                category.id === 'Feedback' ? 'bg-pink-100' :
                                                    category.id === 'Usuarios' ? 'bg-teal-100' :
                                                        'bg-orange-100'
                                    }`}>
                                    <FontAwesomeIcon
                                        icon={
                                            category.id === 'Quick Start' ? faRocket :
                                                category.id === 'Gestión' ? faCog :
                                                    category.id === 'Marketing' ? faBullhorn :
                                                        category.id === 'Analytics' ? faChartLine :
                                                            category.id === 'Feedback' ? faPoll :
                                                                category.id === 'Usuarios' ? faUser :
                                                                    faQrcode
                                        }
                                        className={`text-xl ${category.id === 'Quick Start' ? 'text-blue-600' :
                                            category.id === 'Gestión' ? 'text-green-600' :
                                                category.id === 'Marketing' ? 'text-purple-600' :
                                                    category.id === 'Analytics' ? 'text-indigo-600' :
                                                        category.id === 'Feedback' ? 'text-pink-600' :
                                                            category.id === 'Usuarios' ? 'text-teal-600' :
                                                                'text-orange-600'
                                            }`}
                                    />
                                </div>
                                <h2 className="text-2xl font-bold text-gray-800">{category.id}</h2>
                                <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                                    {category.guides.length} {category.guides.length === 1 ? 'guía' : 'guías'}
                                </span>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {category.guides.map((guide) => (
                                    <Link
                                        key={guide.id}
                                        to={guide.path}
                                        className="border border-gray-200 rounded-lg p-5 hover:border-blue-300 hover:shadow-md transition-all group bg-white"
                                    >
                                        <div className="flex items-start gap-3 mb-3">
                                            <div className={`p-2 rounded-lg flex-shrink-0 ${category.id === 'Quick Start' ? 'bg-blue-50' :
                                                category.id === 'Gestión' ? 'bg-green-50' :
                                                    category.id === 'Marketing' ? 'bg-purple-50' :
                                                        category.id === 'Analytics' ? 'bg-indigo-50' :
                                                            category.id === 'Feedback' ? 'bg-pink-50' :
                                                                category.id === 'Usuarios' ? 'bg-teal-50' :
                                                                    'bg-orange-50'
                                                }`}>
                                                <FontAwesomeIcon
                                                    icon={guide.icon}
                                                    className={`text-sm ${category.id === 'Quick Start' ? 'text-blue-600' :
                                                        category.id === 'Gestión' ? 'text-green-600' :
                                                            category.id === 'Marketing' ? 'text-purple-600' :
                                                                category.id === 'Analytics' ? 'text-indigo-600' :
                                                                    category.id === 'Feedback' ? 'text-pink-600' :
                                                                        category.id === 'Usuarios' ? 'text-teal-600' :
                                                                            'text-orange-600'
                                                        }`}
                                                />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex items-start justify-between gap-2 mb-2">
                                                    <h3 className="text-base font-semibold text-gray-800 group-hover:text-blue-600 transition-colors line-clamp-2">
                                                        {guide.title}
                                                    </h3>
                                                    <FontAwesomeIcon
                                                        icon={faCheckCircle}
                                                        className="text-green-500 text-sm flex-shrink-0 mt-1"
                                                    />
                                                </div>
                                                <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                                                    {guide.description}
                                                </p>
                                                <div className="flex items-center gap-3 text-xs text-gray-500">
                                                    <span>⏱️ {guide.estimatedTime}</span>
                                                    <span className="flex items-center gap-1 text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity">
                                                        Ver guía
                                                        <FontAwesomeIcon icon={faArrowRight} className="text-xs" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Support Section */}
                <div className="mt-12 bg-gray-50 border border-gray-200 rounded-lg p-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-3">¿Necesitas más ayuda?</h2>
                    <p className="text-gray-600 mb-4">
                        Si no encuentras lo que buscas o tienes alguna pregunta, nuestro equipo de soporte está aquí para ayudarte.
                    </p>
                    <div className="flex flex-wrap gap-4">
                        <a
                            href="mailto:soporte@petitprime.com"
                            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium"
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                            Contactar Soporte
                        </a>
                    </div>
                </div>
            </div>
        </DocumentationLayout>
    );
};

export default DocumentationIndex;

